import { useMemo, useState, useEffect } from 'react';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import type { IGeneralLegendOption } from '@/pages/intelligence/components/GeneralLegend/types';

export default function useLegends(option: { chartType: ChartType; dataList: any }) {
  const { chartType, dataList } = option ?? {};

  const legends = useMemo<IGeneralLegendOption[]>(() => {
    const map: any = {
      [ChartType.BarHorizontal]: dataList?.barsLegends,
      [ChartType.Pie]: dataList?.piesLegends,
    };
    return map[chartType] ?? [];
  }, [chartType, dataList?.barsLegends, dataList?.piesLegends]);

  const [legendsSelected, setLegendsSelected] = useState<{ [key: string]: boolean }>({});

  const handleLegendsSelectedChange = (payload: { [key: string]: boolean }) => {
    const legendsSelectedTmp = {
      ...legendsSelected,
      ...payload,
    };
    setLegendsSelected(legendsSelectedTmp);
  };

  const filterListByLegendsSelected = (
    chartType: ChartType,
    legendsSelected: { [key: string]: boolean },
    list: any,
  ): any => {
    if (chartType === ChartType.Pie) {
      return {
        ...list,
        data: list?.data?.filter((item: any) => legendsSelected?.[item?.name]) ?? [],
      };
    }
    return list?.map((item: any) => ({
      ...item,
      data: item?.data?.filter((subItem: any) => legendsSelected?.[subItem?.name]) ?? [],
    }));
  };

  useEffect(() => {
    if (!Array.isArray(legends)) {
      setLegendsSelected({});
      return;
    }
    const legendsSelectedTmp = legends.reduce(
      (current, next) => ({ ...current, [next?.name]: next?.name !== 'other' }),
      {},
    );
    setLegendsSelected(legendsSelectedTmp);
  }, [legends]);

  return {
    legends,
    legendsSelected,
    handleLegendsSelectedChange,
    filterListByLegendsSelected,
  };
}
